const getBluePrices = (technologyAttributes) => {
let bluePricesClass = ''

    if(technologyAttributes) {
        const hasBluePriceAttribute = _.find(technologyAttributes, (attribute) => {
            return attribute.id === 'schnaeppchen' || attribute.id === "pricelevel_N96" || attribute.id === "letzte_chance"
        })

        bluePricesClass = hasBluePriceAttribute ? ' blue-price' : ''
    }

    return bluePricesClass
}

export default getBluePrices